export const hiddenSpan = <span style={{ display: 'none' }} />;
